import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Modal from '../../components/Modal';
import Header from '../../components/Header';
import Button from '../../components/Button';

import ShareCalendarComponent from './share-calendar';
import messages from './messages';
import './styles.css';

const closeButtonIcon = (
  <Button
    id="closeExport"
    icon="close"
    className="close"
    styleName="close"
    aria-label="Close"
  />
);

const ShareCalendar = ({ open, onClose, selectedTab }) => (
  <Modal open={open} size="small" closeIcon={closeButtonIcon} onClose={onClose} styleName="modal">
    <Header as="h3">
      <FormattedMessage {...messages.shareYourCalendar} />
    </Header>
    <Modal.Content>
      <ShareCalendarComponent selectedTab={selectedTab} />
    </Modal.Content>
  </Modal>
);

ShareCalendar.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedTab: PropTypes.number,
};

export default ShareCalendar;
